module.exports = __webpack_public_path__ + "img/play.05ec3ad2.png";